import React from "react";
import { Link } from "react-router-dom";

export default function FooterTwo() {
  return (
    <footer className="sx-footer">
      <div className="sx-footer-container">
        {/* TOP GRID */}
        <div className="sx-footer-grid">
          {/* BRAND */}
          <div className="sx-footer-brand">
            <img
              src="/assets/images/logo/logo-two-black.png"
              alt="Awaneez"
              className="sx-footer-logo"
              style={{ width: "180px" }}
            />

            <p className="sx-footer-desc">
              Awaneez helps individuals and businesses simplify printing. From
              reliable printers to genuine ink and toner, we deliver products
              you can trust backed by fast shipping and expert assistance.
            </p>

            <div className="sx-footer-payments">
              <img
                src="/assets/images/thumbs/payment-method.png"
                alt="Accepted Payment Methods"
              />
            </div>
          </div>

          {/* QUICK LINKS */}
          <div className="sx-footer-col">
            <h5>Quick Links</h5>
            <Link to="/shop">Shop All</Link>
            <Link to="/about-us">About Us</Link>
            <Link to="/contact-us">Contact Us</Link>
            <Link to="/book-an-appointment">Book an Appointment</Link>
          </div>

          {/* CUSTOMER CARE */}
          <div className="sx-footer-col">
            <h5>Customer Care</h5>
            <Link to="/order-track">Track Order</Link>
            <a href="shipping-policy.php" target="_blank">
              Shipping Policy
            </a>
            <a href="refund-policy.php" target="_blank">
              Returns & Refunds
            </a>
          </div>

          {/* CONTACT */}
          <div className="sx-footer-col">
            <h5>Get in Touch</h5>
            <p>Email: info@awaneez.com</p>
            <p>
              Address: 2234 N Federal Hwy, Ste 3162 Boca Raton Florida
              33431-7710
            </p>
            <p>Phone: +1-786-761-8824</p>
          </div>
        </div>

        {/* DIVIDER */}
        <div className="sx-footer-divider" />

        {/* DISCLAIMER */}
        <p className="sx-footer-disclaimer">
          Awaneez is an independent retailer of printer hardware and supplies.
          Brand names and trademarks are used solely for compatibility and
          identification purposes.
        </p>

        {/* BOTTOM */}
        <div className="sx-footer-bottom">
          <span>
            © {new Date().getFullYear()} Awaneez. All rights reserved.
          </span>

          <div className="sx-footer-legal">
            <a href="privacy-policy.php" target="_blank">
              Privacy
            </a>
            <a href="terms-and-conditions.php" target="_blank">
              Terms
            </a>
            <a href="cookie-policy.php" target="_blank">
              Cookies
            </a>
          </div>
        </div>
      </div>

      {/* CSS */}
      <style>{`
        /* ================= FOOTER ================= */
        .sx-footer {
          background: #000;
          color: #cbd5e1;
          padding: 90px 0 40px;
        }

        .sx-footer-container {
          max-width: 1300px;
          margin: auto;
          padding: 0 20px;
        }

        /* GRID */
        .sx-footer-grid {
          display: grid;
          grid-template-columns: 2.2fr 1fr 1.2fr 1.4fr;
          gap: 50px;
        }

        /* BRAND */
        .sx-footer-logo {
          margin-bottom: 18px;
        }

        .sx-footer-desc {
          font-size: 15px;
          line-height: 1.7;
          margin-bottom: 22px;
          color: #b8c1da;
        }

        .sx-footer-payments img {
          width: 260px;
          opacity: 0.9;
        }

        /* COLUMNS */
        .sx-footer-col h5 {
          font-size: 16px;
          font-weight: 700;
          color: #ffffff;
          margin-bottom: 18px;
        }

        .sx-footer-col a,
        .sx-footer-col p {
          display: block;
          color: #b8c1da;
          font-size: 14px;
          text-decoration: none;
          margin-bottom: 10px;
          line-height: 1.6;
        }

        .sx-footer-col a:hover {
          color: #ffffff;
        }

        /* DIVIDER */
        .sx-footer-divider {
          height: 1px;
          background: rgba(255,255,255,0.08);
          margin: 50px 0 30px;
        }

        /* DISCLAIMER */
        .sx-footer-disclaimer {
          max-width: 1000px;
          margin: 0 auto 28px;
          font-size: 13px;
          line-height: 1.6;
          text-align: center;
          color: #94a3b8;
        }

        /* BOTTOM */
        .sx-footer-bottom {
          display: flex;
          justify-content: space-between;
          align-items: center;
          flex-wrap: wrap;
          gap: 16px;
          font-size: 14px;
          color: #94a3b8;
        }

        .sx-footer-legal {
          display: flex;
          gap: 18px;
        }

        .sx-footer-legal a {
          color: #b8c1da;
          text-decoration: none;
        }

        .sx-footer-legal a:hover {
          color: #ffffff;
        }

        /* MOBILE */
        @media(max-width: 900px) {
          .sx-footer-grid {
            grid-template-columns: 1fr;
            gap: 40px;
          }

          .sx-footer-bottom {
            flex-direction: column;
            text-align: center;
          }
        }
      `}</style>
    </footer>
  );
}
